export const pageReload = (executeBeforeRefresh) => {
  if (executeBeforeRefresh) {
    executeBeforeRefresh();
  }

  window.location.reload();
};
